import { theme } from './theme';

export function GlobalStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Outfit:wght@300;400;500;600;700&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap');

      * { margin: 0; padding: 0; box-sizing: border-box; }

      body {
        font-family: ${theme.fontFamily.base};
        background: ${theme.colors.paper};
        color: ${theme.colors.navy};
        min-height: 100vh;
        line-height: 1.5;
        -webkit-font-smoothing: antialiased;
      }

      /* Authenticator custom styles */
      .amplify-authenticator {
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, ${theme.colors.navy} 0%, ${theme.colors.navy} 100%);
      }

      .amplify-authenticator > div {
        width: 100%;
        max-width: 420px;
      }

      .amplify-card {
        background: white !important;
        border-radius: 16px !important;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
        padding: 2rem !important;
      }

      .amplify-field-group__group {
        margin-bottom: 1rem;
      }

      .amplify-label {
        font-size: 0.875rem !important;
        font-weight: 500 !important;
        color: ${theme.colors.textMuted} !important;
        margin-bottom: 0.5rem !important;
      }

      .amplify-input {
        border: 1px solid ${theme.colors.border} !important;
        border-radius: 8px !important;
        padding: 0.75rem 1rem !important;
        font-size: 1rem !important;
        transition: border-color 0.2s, box-shadow 0.2s !important;
      }

      .amplify-input:focus {
        border-color: ${theme.colors.teal} !important;
        box-shadow: 0 0 0 3px ${theme.colors.tealBg} !important;
        outline: none !important;
      }

      .amplify-button--primary {
        background: linear-gradient(135deg, ${theme.colors.teal} 0%, ${theme.colors.teal} 100%) !important;
        border: none !important;
        border-radius: 8px !important;
        padding: 0.75rem 1.5rem !important;
        font-size: 1rem !important;
        font-weight: 600 !important;
        color: white !important;
        width: 100% !important;
        margin-top: 1rem !important;
        transition: transform 0.1s, box-shadow 0.2s !important;
      }

      .amplify-button--primary:hover {
        transform: translateY(-1px);
        box-shadow: ${theme.shadows.button} !important;
      }

      .amplify-button--primary:active {
        transform: translateY(0);
      }

      .amplify-tabs {
        display: none !important;
      }

      .amplify-footer {
        display: none !important;
      }

      .amplify-sign-up-footer,
      .amplify-form-section-footer {
        display: none !important;
      }

      h2.amplify-heading {
        font-size: 1.5rem !important;
        font-weight: 600 !important;
        color: ${theme.colors.navy} !important;
        text-align: center !important;
        margin-bottom: 1.5rem !important;
      }

      p.amplify-text {
        font-size: 0.875rem !important;
        color: ${theme.colors.textMuted} !important;
      }

      input, select, button, textarea { font-family: inherit; }
      button { cursor: pointer; }
      input:focus, select:focus, button:focus, textarea:focus { outline: none; }
      ul, ol { padding-left: 1.5rem; }

      select {
        appearance: none;
        background-image: url('data:image/svg+xml;charset=UTF-8,<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5L7 9L11 5" stroke="%23333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        background-repeat: no-repeat;
        background-position: right 1rem center;
        background-size: 14px;
        padding-right: 2.5rem;
      }

      /* Ghost input — borderless underline style */
      .ghost-input {
        border: none !important;
        border-bottom: 2px solid ${theme.colors.border} !important;
        border-radius: 0 !important;
        background: transparent !important;
        font-family: ${theme.fontFamily.display} !important;
        font-size: 1.6rem !important;
        font-weight: 300 !important;
        text-align: center;
        padding: 0.5rem 0 !important;
        width: 100%;
        color: ${theme.colors.navy};
        transition: border-color 0.2s;
      }
      .ghost-input::placeholder { color: ${theme.colors.border}; }
      .ghost-input:focus { border-bottom-color: ${theme.colors.teal} !important; }

      /* Chip pop animation */
      @keyframes chipPop {
        0%   { transform: scale(1); }
        40%  { transform: scale(1.1); }
        100% { transform: scale(1); }
      }
      .chip-pop { animation: chipPop 0.2s ease-out; }

      /* Connie gradient utility */
      .connie-gradient { background: ${theme.gradients.primary}; }

      /* Glass morphism */
      .glass {
        background: rgba(255,255,255,0.4);
        backdrop-filter: blur(24px);
        -webkit-backdrop-filter: blur(24px);
        border: 1px solid rgba(255,255,255,0.2);
        box-shadow: 0 20px 60px rgba(0,0,0,0.1);
      }

      /* Mask fade bottom */
      .mask-fade-bottom {
        mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
        -webkit-mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
      }

      /* Animations */
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.4; }
      }
      @keyframes bounce {
        0%, 80%, 100% { transform: scale(0); }
        40% { transform: scale(1); }
      }
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideIn {
        from { opacity: 0; transform: translateY(16px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      @keyframes slideInLeft {
        from { opacity: 0; transform: translateX(-16px); }
        to   { opacity: 1; transform: translateX(0); }
      }
      @keyframes drop {
        from { transform: translate(-50%, -300%); opacity: 0; }
        to   { transform: translate(-50%, -100%); opacity: 1; }
      }

      .fade-in      { animation: fadeIn   ${theme.transitions.normal} ease-out; }
      .slide-in     { animation: slideIn  ${theme.transitions.slow}   ease-out; }
      .slide-in-left{ animation: slideInLeft ${theme.transitions.normal} ease-out; }

      /* Primary action button */
      .btn-primary {
        background: ${theme.colors.navy};
        color: white;
        border: none;
        border-radius: ${theme.borderRadius.full};
        font-weight: ${theme.fontWeight.bold};
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing.sm};
        box-shadow: ${theme.shadows.button};
        transition: background ${theme.transitions.fast}, transform ${theme.transitions.fast}, box-shadow ${theme.transitions.fast};
      }
      .btn-primary:hover {
        background: ${theme.colors.teal};
        transform: translateY(-2px);
      }
      .btn-primary:active {
        transform: translateY(0);
      }

      .btn-secondary {
        background: ${theme.colors.white};
        color: ${theme.colors.muted};
        border: 1px solid ${theme.colors.border};
        border-radius: ${theme.borderRadius.full};
        font-weight: ${theme.fontWeight.bold};
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing.sm};
        padding: ${theme.spacing.md} ${theme.spacing['2xl']};
        font-size: 10px;
        text-transform: uppercase;
        letter-spacing: 0.15em;
        transition: color ${theme.transitions.fast}, border-color ${theme.transitions.fast};
      }
      .btn-secondary:hover {
        color: ${theme.colors.navy};
        border-color: ${theme.colors.navy};
      }

      /* Mobile responsive */
      @media (max-width: ${theme.breakpoints.tablet}) {
        .ghost-input {
          font-size: 1.2rem !important;
        }
        .btn-primary, .btn-secondary {
          padding: ${theme.spacing.md} ${theme.spacing.xl};
          font-size: ${theme.fontSize.sm};
        }
      }

      @media print {
        .no-print { display: none !important; }
        body { background: white !important; }
        header, footer { display: none !important; }
      }
    `}</style>
  );
}
